// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JuAN","type":"styles_type__1IDu1","choices":"styles_choices__3p4d7"};